(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legal-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const links = document.querySelectorAll('[data-legal-link]');
    if (!links.length || !('IntersectionObserver' in window)) return;
    const byId = new Map([...links].map((link) => [link.dataset.legalLink, link]));
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          links.forEach((link) => link.classList.remove('is-active'));
          byId.get(entry.target.id)?.classList.add('is-active');
        });
      },
      { rootMargin: '-20% 0px -70% 0px' }
    );
    byId.forEach((_, id) => {
      const target = document.getElementById(id);
      if (target) observer.observe(target);
    });
  })();

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-cookie-preferences]');
    if (!link || !window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') return;
    event.preventDefault();
    window.privacyBanner.showPreferences();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-authors"]) return;
  try {
    
  if (!customElements.get('author-directory')) {
    class AuthorDirectory extends HTMLElement {
      connectedCallback() {
        this.items = [...this.querySelectorAll('.author-directory__item')];
        this.search = this.querySelector('#AuthorSearch');
        this.imprint = this.querySelector('#AuthorImprint');
        this.letters = [...this.querySelectorAll('button[data-letter]')];
        this.status = this.querySelector('[data-author-status]');
        this.empty = this.querySelector('[data-author-empty]');
        this.letter = '';

        this.search?.addEventListener('input', () => this.filter());
        this.imprint?.addEventListener('change', () => this.filter());
        this.letters.forEach((button) =>
          button.addEventListener('click', () => {
            this.letter = this.letter === button.dataset.letter ? '' : button.dataset.letter;
            this.letters.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.letter === this.letter)));
            this.filter();
          })
        );
      }

      filter() {
        const query = (this.search?.value || '').trim().toLowerCase();
        const imprint = this.imprint && this.imprint.selectedIndex > 0 ? this.imprint.value : '';
        let shown = 0;
        this.items.forEach((item) => {
          const match =
            (!query || item.dataset.name.includes(query)) &&
            (!this.letter || item.dataset.letter === this.letter) &&
            (!imprint || item.dataset.imprints.split(',').includes(imprint));
          item.hidden = !match;
          if (match) shown += 1;
        });
        this.empty.hidden = shown > 0;
        this.status.textContent = this.dataset.countTemplate
          ? this.dataset.countTemplate.replace('[count]', shown)
          : `${shown}`;
      }
    }
    customElements.define('author-directory', AuthorDirectory);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-book"]) return;
  try {
    
  if (!customElements.get('book-buy')) {
    class BookBuy extends HTMLElement {
      connectedCallback() {
        const data = this.querySelector('[data-book-variants]');
        this.variants = data ? JSON.parse(data.textContent) : [];
        this.variantInput = this.querySelector('[data-book-variant-input]');
        this.price = this.querySelector('[data-book-price]');
        this.addButton = this.querySelector('.book-buy__add');
        this.addLabel = this.querySelector('[data-book-add-label]');
        this.printPanel = this.querySelector('[data-print-panel]');
        this.digitalPanel = this.querySelector('[data-digital-panel]');
        this.quantity = this.querySelector('.quantity-stepper__input');

        this.querySelectorAll('.format-chip__input').forEach((input) =>
          input.addEventListener('change', () => this.select(Number(input.value)))
        );
        this.querySelectorAll('[data-qty]').forEach((button) =>
          button.addEventListener('click', () => {
            const next = Math.max(1, (parseInt(this.quantity.value, 10) || 1) + Number(button.dataset.qty));
            this.quantity.value = next;
          })
        );

        const checked = this.querySelector('.format-chip__input:checked');
        if (checked) this.select(Number(checked.value), false);
      }

      select(id, updateUrl = true) {
        const variant = this.variants.find((v) => v.id === id);
        if (!variant) return;
        if (this.variantInput) this.variantInput.value = id;
        if (this.price) {
          this.price.innerHTML = (variant.compare ? `<s class="book-buy__compare">${variant.compare}</s>` : '') + `<span>${variant.price}</span>`;
        }
        if (this.addButton) {
          this.addButton.disabled = !variant.available;
          this.addLabel.textContent = variant.available
            ? this.addLabel.dataset.template?.replace('[price]', variant.price) || this.addLabel.textContent
            : this.dataset.soldOut || this.addLabel.textContent;
        }
        if (this.printPanel) this.printPanel.hidden = variant.digital;
        if (this.digitalPanel) this.digitalPanel.hidden = !variant.digital;
        this.querySelectorAll('[data-retailers-for]').forEach((group) => {
          group.hidden = Number(group.dataset.retailersFor) !== id;
        });
        const isbn = document.querySelector('[data-book-isbn]');
        if (isbn) {
          isbn.textContent = variant.isbn || '';
          isbn.closest('[data-book-isbn-row]').hidden = !variant.isbn;
        }
        if (updateUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', id);
          window.history.replaceState({}, '', url);
        }
      }
    }
    customElements.define('book-buy', BookBuy);
  }

  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-cover-zoom]');
    if (open) {
      open.closest('.book-gallery')?.querySelector('[data-cover-dialog]')?.showModal();
      return;
    }
    const dialog = event.target.closest('[data-cover-dialog]');
    if (dialog && (event.target === dialog || event.target.closest('[data-cover-close]'))) dialog.close();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-submission"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('submission-panel')) {
    class SubmissionPanel extends HTMLElement {
      connectedCallback() {
        this.addEventListener('submit', (event) => this.onSubmit(event));
        this.bind();
      }

      get form() {
        return this.querySelector('form.submission-form');
      }

      bind() {
        const form = this.form;
        if (!form || form.dataset.ajaxBound) return;
        form.dataset.ajaxBound = 'true';
        form.submit = () => this.send(form);
      }

      onSubmit(event) {
        const form = event.target.closest('form.submission-form');
        if (!form) return;
        const captcha = window.Shopify && window.Shopify.captcha;
        if (captcha && !form.dataset.hcaptchaBound) return;
        event.preventDefault();
        this.send(form);
      }

      async send(form) {
        if (this.sending) return;
        this.sending = true;
        const button = form.querySelector('[type="submit"]');
        const label = button ? button.textContent : '';
        if (button) {
          button.disabled = true;
          button.textContent = this.dataset.sendingLabel || label;
        }
        this.setAttribute('aria-busy', 'true');

        try {
          const action = form.getAttribute('action').split('#')[0];
          const response = await fetch(action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' });
          const html = await response.text();
          const next = new DOMParser().parseFromString(html, 'text/html').getElementById(this.id);
          if (!response.ok || !next) throw new Error('Unexpected response');
          this.innerHTML = next.innerHTML;
          this.bind();
          const message = this.querySelector('.submission-form__success, .submission-form__errors');
          if (message) {
            message.scrollIntoView({ block: 'center', behavior: 'smooth' });
            message.focus({ preventScroll: true });
          }
        } catch (error) {
          HTMLFormElement.prototype.submit.call(form);
        } finally {
          this.sending = false;
          this.removeAttribute('aria-busy');
          const current = this.querySelector('[type="submit"]');
          if (current && current === button) {
            current.disabled = false;
            current.textContent = label;
          }
        }
      }
    }
    customElements.define('submission-panel', SubmissionPanel);
  }

  } catch(e) { console.error(e); }
})();
})();
